export const environment = {
    production: false,
    hmr: false,
    useStubs: false,
    getTokenUrl: '',
    vragenboomUrl: '',
    indienenVragenboomUrl: '',
    claimAfrondenUrl: '',
    claimVoorbereidenUrl: '',
    insuranceUrl: '',
    relatieUrl: '',
    verzekeringskiezerUrl: '',
    keepAliveUrl: '',
    applicationInsightsKeyUrl: '',
    signOutUrl: '',
    chatConfigurationUrl: '',
    raadplegenBestandenUrl: '',
    raadplegenBestandDetailsUrl: '',
    raadplegenClaimDetailsUrl: '',
    raadplegenClaimnummerUrl: '',
    codeSoortVerzekeringUrl: '',
    detailTitelsUrl: '',
    betalingTekstenUrl: '',
    oplossingTekstenUrl: '',
    openingstijdenUrl: '',
    tekstenUrl: '',
    productinfoUrl: '',
    claimOverviewUrl: '',
    graphQLUrl: '',
    siteSettingsUrl: '',
    ophalenClientDetailsUrl: '',
    ophalenPlaatsnamenUrl: '',
    ophalenHerstelBedrijvenUrl: '',
    ophalenRuitherstellersUrl: '',
    ophalenWoonglasschadeherstellersUrl: ''
};
